module.exports = __webpack_public_path__ + "img/mapPoint3PL.02ab935b.svg";